import React, {
  Fragment, ReactElement, useEffect, useState,
} from 'react'
import {
  IAddToBasket,
  IGiftItemResponse,
  IColorTheme,
} from '../../types/itemTypes'
import Quantity from './Quantity'
import Value from './Value'
import { CurrencyCode } from '../../types/API'
import { BuyButton } from './ItemButtonStyles'
import { isGiftVoucher } from '../../helpers/itemHelper'

export interface IItemButtonsProps extends IAddToBasket {
  giftItem: IGiftItemResponse
  currency: CurrencyCode
  colorTheme: IColorTheme
  individuals: number
  soldOut: boolean
  showQuantity: boolean
}
export default function ItemPurchaseButtons({
  giftItem,
  currency,
  addToBasket,
  colorTheme,
  individuals,
  soldOut,
  showQuantity,
}: IItemButtonsProps): ReactElement | null {
  const {
    value, maxPerOrder, quantitySold, quantity,
  } = giftItem
  const isMonetary = value?.includes(',')

  const initValue = (): number => {
    if (!value) return 0
    if (isMonetary) return parseFloat(value.split(',')[0])
    return parseFloat(value)
  }
  const [selectedValue, setSelectedValue] = useState<number>(initValue())

  useEffect(() => {
    // Run init on `value` change too, to ensure latest price
    setSelectedValue(initValue())
  }, [value])

  const [selectedQuantity, setSelectedQuantity] = useState<number>(1)

  const soldOutOrInvalid = soldOut || !value

  const noSelectedValue = !(selectedValue || selectedValue === 0)
  if (noSelectedValue) return null

  const freeWording = isGiftVoucher(giftItem) ? 'Select' : 'Book'
  const label = selectedValue === 0 ? freeWording : 'Buy'

  return (
    <Fragment>
      {isMonetary && value && (
        <Value
          values={value}
          currency={currency}
          selectedValue={selectedValue}
          selectValue={setSelectedValue}
          colorTheme={colorTheme}
        />
      )}
      {showQuantity && !soldOutOrInvalid && (
        <Quantity
          maxPerOrder={maxPerOrder}
          selectedQuantity={selectedQuantity}
          selectQuantity={setSelectedQuantity}
          colorTheme={colorTheme}
          quantitySold={quantitySold}
          quantity={quantity}
        />
      )}
      <BuyButton
        onClick={(): void => {
          if (addToBasket) {
            addToBasket(giftItem, selectedValue, selectedQuantity, individuals)
          }
        }}
        disabled={soldOutOrInvalid}
        className={soldOutOrInvalid ? 'sold-out' : ''}
        theme={colorTheme}
      >
        {!soldOutOrInvalid ? label : 'Sold out'}
        {!soldOutOrInvalid && <div className="buy-button-chevron" />}
      </BuyButton>
    </Fragment>
  )
}
